import { GET_TOKEN } from "../actions/AuthAction";

const initialState = {
    token : null,   
    roles: [] 
}

const AuthReducer = (state = initialState, action)=>{
    switch(action.type){
        case GET_TOKEN:
            return {...state, token:action.token, roles:action.roles}
        default:
            return {...state}
    }
}

export default AuthReducer;

